import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { QuestionCompact } from '@ratehub/base-ui';

import { AMORTIZATION_OPTIONS_EXTENDED } from '../definitions/AmortizationTermOptions';
import AMORTIZATION_MESSAGES from '../definitions/AmortizationTermMessages';


// Other uses of this shared definition require strings, we want numbers.
const AMORITZATION_OPTIONS_NUMBER = AMORTIZATION_OPTIONS_EXTENDED.map(item => Number(item));

function QuestionAmortization({ name, value, ...otherProps }) {
    return (
        <QuestionCompact
            field={{
                name: name,
                type: 'choice',
                value: value,
                options: AMORITZATION_OPTIONS_NUMBER,
            }}
            // Used to format the message into "{term}-year"
            renderOptionLabel={term => (
                <FormattedMessage
                    {...AMORTIZATION_MESSAGES.TERM_MESSAGE}
                    values={{ term }}
                />
            )}
            labelMessage={(
                <FormattedMessage
                    id="web-components.mortgageRateTableV2+Filter.purchaseAmortizationLabel"
                    defaultMessage="Amortization"
                />
            )}
            type="dropdown"
            {...otherProps}
        />
    );
}

QuestionAmortization.propTypes = {
    name: PropTypes.string,
    value: PropTypes.oneOf(AMORITZATION_OPTIONS_NUMBER),
};

QuestionAmortization.defaultProps = {
    name: 'amortization',
    value: undefined,
};

export default QuestionAmortization;